export default class MedicalProvider {
	constructor() {
		this.medicalProviderName = null;
		this.speciality = null;
		this.dateStart = null;
		this.dateEnd = null;
	}
}
